import React, { Component } from 'react'
import { Alert } from '@mui/material'

class DisplayItemEmailSettings extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div>
                <h3>{this.props.kedo.t('Settings')}</h3>
                <Alert severity={'info'}>
                    {this.props.kedo.t('No settings available')}
                </Alert>
            </div>
        )
    }
}

export default DisplayItemEmailSettings
